
<template>
    <div class="form-overlay select-mention" :class="position">   

        <div class="steep1">
            <div class="nav-network hide-scrollbar">
                <div class="list-item-network" v-if="!networks || networks.length > 1">
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'facebook') && (!networks || networks.includes('facebook'))" :class="{active : networkSelected == 'facebook'}" @click="()=>selectNetwork('facebook')"><i class="fa-brands fa-facebook"></i></div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'instagram') && (!networks || networks.includes('instagram'))" :class="{active : networkSelected == 'instagram'}" @click="()=>selectNetwork('instagram')"><i class="fa-brands fa-instagram"></i></div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'linkedin') && (!networks || networks.includes('linkedin'))" :class="{active : networkSelected == 'linkedin'}" @click="()=>selectNetwork('linkedin')"><i class="fa-brands fa-linkedin"></i></div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'twitter') && (!networks || networks.includes('twitter'))" :class="{active : networkSelected == 'twitter'}" @click="()=>selectNetwork('twitter')"><i class="fa-brands fa-twitter"></i></div>
                    <div class="item-network bluesky" v-if="this.pagesSelected.find(p=> p.network == 'bluesky') && (!networks || networks.includes('bluesky'))" :class="{active : networkSelected == 'bluesky'}" @click="()=>selectNetwork('bluesky')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z"/></svg>
                    </div>
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'tiktok' && (p.story_config && p.story_config.created || p.bot_status)) && (!networks || networks.includes('tiktok'))" :class="{active : networkSelected == 'tiktok'}" @click="()=>selectNetwork('tiktok')"><i class="fa-brands fa-tiktok"></i></div>
                </div>
            </div>
            <div class="content searchMention">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input :placeholder="textPlaceholder" v-model="textSearch" v-on:keyup.enter="sendSearchMention" ref="inputSearch">
                </div>
                <div class="list-item list-chosen-item hide-scrollbar">
                    <div class="item chosen-item" v-if="mentionData.mention && mentionData.mention[networkSelected]">
                        <div class="image">
                            <img :src="mentionData.mention[networkSelected].image ? mentionData.mention[networkSelected].image : saveUrlPictureUser[mentionData.mention[networkSelected].id] ? saveUrlPictureUser[mentionData.mention[networkSelected].id] : 'img/avatar.jpg'" alt="">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div class="info">
                            <p class="username">{{ getUsername(mentionData.mention[networkSelected]) }}</p>
                            <p class="name">{{ getSubName(mentionData.mention[networkSelected])}}</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="handleRemoveMention(networkSelected)"></i>
                    </div>
                </div>
                <div class="list-item hide-scrollbar">
                    <p class="no-result" v-if="maxMentionsReached">{{ $t('dash.post-creator.overlay.max-mentions') }}</p>
                    <span class="loader" v-else-if="stateLoader"></span>
                    <template v-else-if="listPersonsAvailableComputed.length">
                        <div class="item"  v-for="person in listPersonsAvailableComputed" @click="selectMention(person)" :key="person.id">
                            <img :src="getPicture(person)" alt="">
                            <div class="info">
                                <p class="username">{{ getUsername(person) }}</p>
                                <p class="name">{{ getSubName(person) }}</p>
                            </div>
                        </div>
                    </template>
                  
                    <template v-else-if="textSearch">
                            <p v-if="mentionData.mention && mentionData.mention[networkSelected]" class="no-result">{{ $t('dash.post-creator.overlay.no-other-account') }}</p>
                            <p v-else class="no-result">{{ $t('dash.post-creator.overlay.no-account') }}</p>
                    </template>
                   
                    
                </div>
            </div>

        </div>
        <div v-if="steep == 1" class="btn-secondary" @click="handleClose">{{ $t('dash.button.close') }}</div>
        <div v-else class="btn-secondary" @click="steep = 1">{{ $t('dash.button.go_back') }}</div>
       
    </div>
</template>


<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js'
    import Queuer from '@/utils/Queuer.js'
    import mixinBot from '@/components/mixins/Bots.vue'
    import { countMentionsPerNetwork } from '@/components/dash/postCreator/utils.js'
    import { maxMentionsByNetwork } from '@/components/dash/postCreator/constante.js'

    const networkSort = ['facebook','instagram','linkedin','twitter','tiktok','bluesky']

    export default {
        mixins: [mixinBot],
        props: {
            mentionData: {
                type: Object,
                default: ()=>({})
            },
            idMention: {
                type: Number,
                default: null
            },
            position: {
                type: String,
                default: 'left'
            },
            networks: {
                type: Array,
                default: null
            },
            text: {
                type: String,
                default: null
            },
            mentions: {
                type: Object,
                default: ()=>({})
            },

            searchMention: {
                type: Function,
                default: null
            },
            addMention: {
                type: Function,
                default: null
            },
            removeMention: {
                type: Function,
                default: null
            },
            close: {
                type: Function,
                default: null
            }
        },
        

        data() {
            return {
                steep : 1,
                textSearch : this.mentionData.textDefault,
                lastIdEvent : 0,
                stateLoader : false,
                listPersonsAvailable : [],
                timeoutInitSearch : null,
                networkSelected :  null,

                saveUrlPictureUser : {},
                queueLoadImage : null,
                maxMentionByNetwork : {
                    facebook: maxMentionsByNetwork.facebook,
                    instagram: 20,
                    linkedin: 20,
                    twitter: 20,
                    bluesky: 20,
                    tiktok: 20
                }
            }
        },

        mounted() {
            EventBus.$on('resultSearchFromSelectMention', this.receivedPerson);
            
            this.$nextTick(() => {
                this.$refs.inputSearch.focus();
            })

            this.networkSelected = networkSort.find(network => 
                (!this.networks || !this.networks.length || this.networks.includes(network)) && this.pagesSelected.some(pageItem => pageItem.network === network)
            )
            this.sendSearchMention()
        },

        methods: {
            handleClose() {
                if (this.close) this.close()
                else EventBus.$emit("eventCloseSelectMention",this.idMention)
                this.$emit('close')
            },

            async sendSearchMention() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                if (this.textSearch) {
                    this.stateLoader = true
                    const generatedIdEvent = new Date().getTime()
                    this.lastIdEvent = generatedIdEvent

                    if (this.searchMention) {
                        const result = await this.searchMention(this.textSearch, this.networkSelected)
                        this.receivedPerson(result, generatedIdEvent)
                    } else {
                        EventBus.$emit("eventSearchFromSelectMention",this.textSearch, this.networkSelected, generatedIdEvent, this.idMention)
                    }
                }else{
                    this.stateLoader = false
                }
            },

            async receivedPerson(persons,idEvent) {
                if (this.lastIdEvent == idEvent) {
               
                    this.stateLoader = false

                    if (persons) {
                        this.listPersonsAvailable = persons
                    }else{
                        this.listPersonsAvailable  = []
                        return
                    }
                              
                    switch (this.networkSelected) {
                        case 'facebook': {

                            let pageFacebook = this.pagesSelected.find(p=> p.network == this.networkSelected)
                            if (pageFacebook) {

                                persons.forEach(m => {
                                    if (m.picture && m.picture.data && m.picture.data.url && !(m.id in this.saveUrlPictureUser)) {
                                        this.$set(this.saveUrlPictureUser, m.id, m.picture.data.url);
                                    }
                                });

                                const personsWithoutPicture = persons.filter(m => !(m.id in this.saveUrlPictureUser));

                                if (personsWithoutPicture.length > 0) {
                                    if (this.queueLoadImage instanceof Queuer) this.queueLoadImage.stop();

                                    this.queueLoadImage = new Queuer({
                                        group: 5,
                                        data: JSON.parse(JSON.stringify(personsWithoutPicture)),
                                        task: async (m) => {
                                            if (!(m.id in this.saveUrlPictureUser)) {
                                                const res = await this.getAvatarMentionByApi(pageFacebook.id, m.id);
                                                if (res && res.body && res.body.avatar && res.body.avatar.data && res.body.avatar.data.url) {
                                                    this.$set(this.saveUrlPictureUser, m.id, res.body.avatar.data.url);
                                                }
                                            }
                                            this.queueLoadImage.unlock()
                                        }
                                    })
                                    this.queueLoadImage.init()
                                }
                            }
                            break;
                        }
                    }
                }
            },

            selectMention(person) {
                this.$set(this.mentionData.mention, this.networkSelected, person)
                if (this.addMention) {
                    this.addMention(this.networkSelected, person)
                } else {
                    EventBus.$emit("eventClickSelectMention",this.networkSelected, person, this.idMention)
                }
                this.steep = 1
            },

            handleRemoveMention(networkSelected) {
                this.$set(this.mentionData.mention, networkSelected, null)
                if (this.removeMention) {
                    this.removeMention(networkSelected)
                } else {
                    EventBus.$emit("eventRemoveSelectMention", networkSelected, this.idMention)
                }
            },

            selectNetwork(network) {
                if (this.networkSelected !== network) {
                    this.listPersonsAvailable = []
                }
                
                this.networkSelected = network
                this.sendSearchMention() 
            },

            getUsername(person) {
                switch (this.networkSelected) {
                    case 'facebook': {
                        return person.name ? person.name : person.id
                    }
                    case 'linkedin': {
                        return person.name ? person.name : person.id
                    }
                    case 'twitter': {
                        return person.name ? person.name : person.id
                    }
                    case 'bluesky': {
                        return person.name ? person.name : person.id
                    }
                    case 'tiktok': {
                        return person.name ? person.name : person.unique_id
                    }
                    default: {
                        return person.id ? person.id : person.name
                    }
                }
            },

            getSubName(person) {
                switch (this.networkSelected) {
                    case 'facebook': {
                        return person.id ? person.id : person.name
                    }

                    case 'linkedin': {
                        return person.subtitle ? person.subtitle : person.name
                    }

                    case 'twitter': {
                        return person.username ? person.username : person.id
                    }
                    case 'bluesky': {
                        return person.subtitle ? person.subtitle : person.id
                    }
                    case 'tiktok': {
                        return person.unique_id ? person.unique_id : person.name
                    }
                    default: {
                        return person.id ? person.id : person.name
                    }
                }
            },

            getPicture(person) {

                switch (this.networkSelected) {
                    case 'twitter': {
                        return person.profile_image_url ? person.profile_image_url : 'img/avatar.jpg'
                    }

                    case 'facebook': {
                        return this.saveUrlPictureUser[person.id] ? this.saveUrlPictureUser[person.id] : 'img/avatar.jpg'
                    }

                    case 'tiktok': {
                        return person.image ? person.image : 'img/avatar.jpg'
                    }

                    default:{
                        return person.image ? person.image : 'img/avatar.jpg'
                    }
                }

            }

        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },

            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            mentionSelected() {
                return this.mentionData.mention[this.networkSelected]
            },

            textPlaceholder() {
                switch (this.networkSelected) {
                    case 'instagram':
                        if (!this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)) {
                            return this.$t('dash.post-creator.overlay.search-mention-account')
                        }

                        break;
                    case 'linkedin':
                        if (!this.pagesSelected.find(p => p.network == 'linkedin' && p.bot_status && p.story_config && p.story_config.created)) {
                            return this.$t('dash.post-creator.overlay.search-mention-company')
                        }

                        break;
                    case 'twitter':
                        return this.$t('dash.post-creator.overlay.search-mention-person')
                    case 'tiktok':
                        if (!this.pagesSelected.find(p => p.network == 'tiktok' && (p.story_config && p.story_config.created || p.bot_status))) {
                            return this.$t('dash.post-creator.overlay.mention-tiktok-concierge')
                        }
                        break;
                }

                return this.$t('dash.post-creator.overlay.search-person')
            },
            listPersonsAvailableComputed() {
                return this.listPersonsAvailable.filter(p => !this.mentionData.mention || !this.mentionData.mention[this.networkSelected] || p.id !== this.mentionData.mention[this.networkSelected].id)
            },

            countMentionPerNetwork() {
                return countMentionsPerNetwork(this.text, this.mentions)
            },

            // une mention éditée qui cible déjà ce réseau est déjà dans le compte : changer la
            // personne ciblée ne fait pas grimper le total, on laisse donc la liste accessible
            maxMentionsReached() {
                const alreadyTargeted = this.mentionData.mention && this.mentionData.mention[this.networkSelected]
                return !alreadyTargeted && this.countMentionPerNetwork[this.networkSelected] >= this.maxMentionByNetwork[this.networkSelected]
            }
        },

        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                if (newValue) {
                    this.stateLoader = true
                    this.timeoutInitSearch = setTimeout(() => {
                        this.sendSearchMention()
                    },1000)
                }else{
                    this.stateLoader = false
                }
            },

           
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectMention', this.receivedPerson);
            if (this.queueLoadImage instanceof Queuer) this.queueLoadImage.stop();
        }
    }
</script>
    